
/* global H5PStandalone */
import React from 'react';

const Qubisa2 = () => {
  return (
    <iframe
      src="/qubisa-2/index.html"
      title="H5P GameMap"
      width="100%"
      height="1000px"
      frameBorder="0"
      allowFullScreen
    ></iframe>
  );
};

export default Qubisa2;